const Home = () => {
  return (
    <section className="mt-[100px] my-5 mx-2 flex flex-col md:flex-row justify-center items-center md:space-x-5 lg:grid-cols-3">
      <img src="images/logos/full-512.png" alt="" className="w-96" />
    </section>
  );
};

export default Home;
